import { AccessTime, AttachFile, CalendarMonth, MedicalInformation, PermContactCalendar, Spa, Vaccines } from '@mui/icons-material'
import { Chip } from '@mui/material'
import moment from 'moment'
import React from 'react'
import { Link } from 'react-router-dom'


const JsonViewer = ({jsonData}) =>{
    const jt = JSON.parse(jsonData);
    return(
        <>
            {jt.length> 0 &&
            <table className="table">
                <thead>
                    <tr className='text-center table-info'>
                        <th colSpan={2}>Details</th>
                    </tr>
                </thead>
                <tbody>
                    {jt.map(data=>
                        <tr>
                            <th>{data.label}</th>
                            <td>{data.value}</td>
                        </tr>
                    )}
                </tbody>
            </table>
            }
        </>
    )
}


function ConsultationTimeline({consultationList}) {
    
  return (
    <div className=" mt-2">
        {consultationList && consultationList.map(r=>
            <div className="" key={r.id}>
                
                <div className='d-flex justify-content-start'>
                    <div className="bg-success text-white d-flex align-items-center justify-content-center" style={{borderRadius:60,width:60, height:60}} > 
                        {r.firstName.charAt(0).toUpperCase()}
                    </div>
                    <div className='ms-2'>
                        <div className='fw-bold'>{r.firstName } {r.lastName }</div>
                        <div className='' style={{fontSize:12}}>
                            <span className='me-2'><CalendarMonth /> {moment(r.created_at).format("DD-MMM YYYY") }</span>
                            <span className='me-2'><AccessTime /> {moment(r.created_at).format("hh:mm A") }</span>
                        </div>
                    </div>
                </div>

                <div className='card my-2 p-3'>
                    <div className='row'>
                        {r.vitales !== null &&
                            <>
                                <div className='col-md-2'>
                                    <h6 className='fw-bold'>Vitals</h6>
                                </div>
                            <div className='col-md-10'>
                                {r.vitales.systolic != null &&
                                    <><span className='fw-bold ms-2'> BP </span> : {r.vitales.systolic} / {r.vitales.diastolic}</>
                                }
                                {r.vitales.pulse != null && <><span className='fw-bold ms-2'> Pulse </span> : {r.vitales.pulse}</> }
                                {r.vitales.bloodSuger != null && <><span className='fw-bold ms-2'> Blood Glucose </span> : {r.vitales.bloodSuger}</> }
                                {r.vitales.spo2 != null && <><span className='fw-bold ms-2'> SPO2 </span> : {r.vitales.spo2}</> }
                                {r.vitales.height != null && <><span className='fw-bold ms-2'> Height </span> : {r.vitales.height}</> }
                                {r.vitales.weight != null && <><span className='fw-bold ms-2'> Weight </span> : {r.vitales.weight}</> }
                                {r.vitales.temperature != null && <><span className='fw-bold ms-2'> Temperature </span> : {r.vitales.temperature}</> }
                            </div>
                        </>
                        }

                        {/*
                        <div className='col-md-2'>
                            <h6 className='fw-bold'>Vitals</h6>
                        </div>
                        <div className='col-md-10'>
                            {r.systolic != "" &&
                                <><span className='fw-bold ms-2'> BP </span> : {r.systolic} / {r.diastolic}</>
                            }
                            {r.pulse != "" && <><span className='fw-bold ms-2'> Pulse </span> : {r.pulse}</> }
                            {r.bloodSuger != "" && <><span className='fw-bold ms-2'> Blood Glucose </span> : {r.bloodSuger}</> }
                            {r.spo2 != "" && <><span className='fw-bold ms-2'> SPO2 </span> : {r.spo2}</> }
                            {r.height != "" && <><span className='fw-bold ms-2'> Height </span> : {r.height}</> }
                            {r.weight != "" && <><span className='fw-bold ms-2'> Weight </span> : {r.weight}</> }
                            {r.temperature != "" && <><span className='fw-bold ms-2'> Temperature </span> : {r.temperature}</> }
                        </div>
                        */}

                        {r.complaint.length > 0 &&
                            <>
                                <div className='col-md-2'>
                                    <h6 className='fw-bold'>Complaints</h6>
                                </div>
                                <div className='col-md-10'>
                                    {r.complaint.map(complaint=> <span span className='p-2 bg-light rounded me-2'>{complaint.complaint}</span>)}
                                </div>
                            </>
                        }

                        {r.diagnosis.length > 0 &&
                            <>
                                <div className='col-md-2'>
                                    <h6 className='fw-bold'>Diagnosis</h6>
                                </div>
                                <div className='col-md-10'>
                                    {r.diagnosis.map(diagnosis=> <span span className='p-2 bg-light rounded me-2'>{diagnosis.diagnosis}</span>)}
                                </div>
                            </>
                        }
                        
                        {r.medicine.length > 0 &&
                            <div className='col-md-12 table-responsive'>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th colSpan={9} className='bg-success text-white text-center'><Vaccines/> Medicines</th>
                                        </tr>
                                        <tr>
                                            <th className='table-primary'>#</th>
                                            <th className='table-success'>Type</th>
                                            <th width={"25%"} className='table-success'>Medicine</th>
                                            <th className='table-success'>Dose</th>
                                            <th className='table-success'>When</th>
                                            <th className='table-success'>Frequency</th>
                                            <th className='table-success'>Duration</th>
                                            <th className='table-success'>Instruction</th>
                                            <th className='table-success'></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {r.medicine.map((medicine,i)=> 
                                            <tr key={medicine.id}>
                                                <th className='table-primary'>{i+1}</th>
                                                <td>{medicine.doseType}</td>
                                                <td>{medicine.medicine}</td>
                                                <td>{medicine.dosePattren}</td>
                                                <td>{medicine.foodPattren}</td>
                                                <td>{medicine.frequency}</td>
                                                <td>{medicine.duration}</td>
                                                <td>{medicine.instructions}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        }

                        {r.therapy.length > 0 &&
                            <div className='col-md-12 table-responsive'>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th colSpan={9} className='table-dark text-warning text-center'><Spa/> Therapies</th>
                                        </tr>
                                        <tr>
                                            <th className='table-primary'>#</th>
                                            <th className='table-success'>Type</th>
                                            <th width={"25%"} className='table-success'>Therapy</th>
                                            <th className='table-success'>Dose</th>
                                            <th className='table-success'>When</th>
                                            <th className='table-success'>Frequency</th>
                                            <th className='table-success'>Duration</th>
                                            <th className='table-success'>Instruction</th>
                                            <th className='table-success'></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {r.therapy.map((therapy,i)=> 
                                            <tr key={therapy.id}>
                                                <th className='table-primary'>{i+1}</th>
                                                <td>{therapy.doseType}</td>
                                                <td>{therapy.therapy}</td>
                                                <td>{therapy.dosePattren}</td>
                                                <td>{therapy.foodPattren}</td>
                                                <td>{therapy.frequency}</td>
                                                <td>{therapy.duration}</td>
                                                <td>{therapy.instructions}</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        }

                        {r.testRequired.length > 0 &&
                            <>
                                <div className='col-md-2'>
                                    <h6 className='fw-bold'>Test Required</h6>
                                </div>
                                <div className='col-md-10'>
                                    {r.testRequired.map(testRequired=> <span span className='p-2 bg-light rounded me-2'>{testRequired.testRequired}</span>)}
                                </div>
                            </>
                        }

                        {r.advice.length >0 &&
                            <>
                                <div className='col-md-2'>
                                    <h6 className='fw-bold'>Advice</h6>
                                </div>
                                <div className='col-md-10'>
                                    {r.advice.map(advice=> <span span className='p-2 bg-light rounded me-2'>{advice.advice}</span>)}
                                </div>
                            </>
                        }

                        {r.nextVisitDate !== null &&
                            <>
                                <div className='col-md-2'>
                                    <h6 className='fw-bold'>Follow Up</h6>
                                </div>
                                <div className='col-md-10'>
                                    <span className='fw-bold'>{r.nextVisitDate}</span>
                                </div>
                            </>
                        }

                        {r.images !== null && r.images.length > 0  &&
                            <div className='col-md-12'>
                                <div style={{width:"100%" ,whiteSpace:"nowrap", overflowX:"auto"}}>
                                    {r.images.map(image=>
                                        <div className='card m-2 float-start'>
                                            
                                            <div className='card-body p-0'>
                                                <Link target='_blank' to={image.url} ><img className='img-fluid' style={{height:400}}  alt="preview image" src={image.url} /></Link>
                                            </div>
                                            <div className='card-body'>
                                                <p>{image.remark}</p>
                                                { image.jsonData !== null &&
                                                    <JsonViewer jsonData={image.jsonData} />
                                                }
                                            </div>
                                            <div className='card-footer'>
                                                <span className='float-start '>{image.fileTitle}</span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        }

                        {r.attachments !== null && r.attachments.length > 0 &&
                            <>
                                <div className='col-md-12'>
                                    {r.attachments.map(attachment=>
                                        <div className='card m-2 float-start'>
                                            <div className='card-body' style={{width:600}}>
                                                <p>{attachment.remark}</p>
                                                {attachment.jsonData !== null &&
                                                    <JsonViewer jsonData={attachment.jsonData} />
                                                }
                                            </div>
                                            <div className='card-footer'>
                                                <Link target='_blank' to={attachment.url} className='m-2'> <AttachFile/> {attachment.fileTitle}</Link>
                                            </div>
                                        </div>
                                        
                                    )}
                                </div>
                            </>
                        }


                        <div className='col-md-12'>
                            {/*JSON.stringify(r)*/}
                        </div>
                    </div>
                </div>
            </div>
        )}
        
    </div>
  )
}

export default ConsultationTimeline